<odl-dialog
  class="unauthorized-dialog"
  [open]="isUnauthorized()"
  (odl-before-close)="preventClose($event)"
>
  <div slot="header" class="header">
    <span>{{ 'UNAUTHORIZED_DIALOG.TITLE' | translate }}</span>
  </div>
  <p class="message">
    {{ 'UNAUTHORIZED_DIALOG.DESCRIPTION' | translate }}
  </p>
  <div slot="footer" class="footer">
    <odl-button (click)="goToPlatform()">{{ 'GO_BACK' | translate }}</odl-button>
  </div>
</odl-dialog>
